<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道" class="EL-Form-Item">
                        <el-select v-model="searchInfo.whCode" filterable placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item">
                        <el-input v-model="searchInfo.laCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="外协单号" class="EL-Form-Item">
                        <el-input v-model="searchInfo.soCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="searchInfo.matCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="searchInfo.boxBarcode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getOutsource()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="状态" class="EL-Form-Item">
                        <el-select v-model="searchInfo.soStatus">
                            <el-option label="全部" value="30,40,80,90"></el-option>
                            <el-option label="进行中" value="30,80,90"></el-option>
                            <el-option label="完成" value="40"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="供应商外协记录列表">
                <el-button v-authority="'BACK_MENU6_M4_B1'" class="btn-t-edit" type="primary" @click="detailsDialogShows = true,getOutsourcePrintList()">打印</el-button>
                <el-button v-authority="'BACK_MENU6_M4_B2'" class="btn-t-edit" type="primary" @click="closeSupplierOutsourcing()">关闭外协单</el-button>
              <!--
              <el-button v-authority="'BACK_MENU6_M4_B5'" class="btn-t-edit" type="primary" @click="confirmReceipt()">确认接收</el-button>
                <el-button v-authority="'BACK_MENU6_M4_B6'" class="btn-t-edit" type="primary" @click="outbound()">出库</el-button>-->
                <!-- <el-button class="btn-t-edit" type="primary" @click="editBoxShow = true,getlaCode()">新增</el-button> -->
                <!-- <el-button class="btn-t-edit" type="primary" @click="manualReport()">手动汇报</el-button> -->
                <!-- <el-button class="btn-t-edit" type="primary" @click="rePrintBarcode()">打印</el-button> -->
                <el-button v-authority="'BACK_MENU6_M4_B3'" :loading=" downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getOutsource" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total" @selectionChange="selectOutsource">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="外协单号" prop="soCode" align="center">
                </el-table-column>
                <el-table-column label="外协供应商" prop="laOutsouceCode" align="center">
                </el-table-column>
                <el-table-column label="状态" prop="soStatus" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.soStatus == '30'">出库完成</div>
                        <div v-if="scope.row.soStatus == '80'">待接收</div>
                        <div v-if="scope.row.soStatus == '90'">发货完成</div>
                        <div v-if="scope.row.soStatus == '40'">完成</div>
                        <div v-if="scope.row.soStatus == '50'">关闭</div>
                    </template>
                </el-table-column>
                <el-table-column label="是否返工" prop="soStatus" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.reworkFlag == '0'">否</div>
                    <div v-if="scope.row.reworkFlag == '1'">是</div>

                  </template>
                </el-table-column>
                <!-- <el-table-column label="操作人" prop="person" palign="center">
                </el-table-column> -->
                <el-table-column label="创建时间" prop="createTime" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU6_M4_B4'" class="btn-t-edit" type="primary" @click="detailsDialogShow = true,getOutsourceDetail(scope.row.soCode)">详情</el-button>
                    </template>
                </el-table-column>
            </h-table>

             <!-- 打印 -->
            <el-dialog title="打印外协列表" :visible.sync="detailsDialogShows" class="infoDialog" :close-on-click-modal="false" :show-close="false">
                <div style="overflow: hidden; padding-bottom: 10px">
                    <el-form label-position="right" label-width="80px" :model="printObjs">
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="外协单号" prop="soCode" class="EL-Form-Item">
                                <el-input v-model.trim="printObjs.soCode"> </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                                <el-input v-model.trim="printObjs.matCode"> </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="批次号" prop="batchNo" class="EL-Form-Item">
                                <el-input v-model.trim="printObjs.batchNo"> </el-input>
                            </el-form-item>
                        </el-col>
                        <el-button type="primary" class="btn-t-delete" style="margin-top:10px;margin-bottom:10px;margin-left:10px;float: right;" @click="deletePrint()">删除</el-button>
                         <el-button type="primary" class="btn-t-edit" style="margin-top:10px;margin-bottom:10px;float: right;" @click="pdfPrint()">打印</el-button>

                        <el-button type="primary" class="btn-t-edit" style="margin-top:10px;margin-bottom:10px;" @click="getOutsourcePrintList()">查询</el-button>
                        </el-form>
                </div>
                <h-table :headerCellStyle="mainData.headerCellStyle" style="height: 56vh" :data="outsourcePrintList" @selectionChange="selectOutsourcePrint">
                    <el-table-column type="selection" align="center">
                    </el-table-column>
                    <el-table-column label="通道" prop="whCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料描述" prop="matName" align="center">
                    </el-table-column>
                    <el-table-column label="数量" prop="boxQuan" palign="center">
                    </el-table-column>
                    <el-table-column label="批次" prop="batchNo" align="center">
                    </el-table-column>
                    <el-table-column label="箱号" prop="boxBarcode" align="center">
                    </el-table-column>
                    <el-table-column label="汇报完成的库位" prop="laCheckCode" align="center">
                    </el-table-column>
                    <el-table-column label="外协单号" prop="soCode" align="center">
                    </el-table-column>
                    <el-table-column label="操作人" prop="person" palign="center">
                    </el-table-column>
                    <el-table-column label="是否扫描接收" prop="scanFlag" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.scanFlag == true"> 是</div>
                            <div v-if="scope.row.scanFlag == false">否</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="更新时间" prop="updateTime" align="center">
                    </el-table-column>
                </h-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogPrintClose" type="info">取 消</el-button>
                </div>
            </el-dialog>

            <!-- 新增-->
            <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="editNumShow" class="fromDialog" :style="$popups.popups(0.8,0.88)" :model="mainObj">
                <div style="overflow: hidden; padding-bottom: 10px">
                    <el-form label-position="right" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="外协单号" prop="soCode" class="EL-Form-Item">
                                <el-input v-model.trim="mainObj.soCode"> </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="3" :xl="3" :offset="16">
                            <el-form-item class="btn-edit-delete EL-Form-Item">
                                <el-button type="primary" class="btn-t-edit" @click="selOutsourceList()">查询</el-button>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </div>
                <div>
                    <h-table :style="$popups.harvestRecordStyle(0.63,0.02)" :headerCellStyle="headerCellStyle" style="flex: 1" :data="addOutsourceList">
                        <el-table-column label="通道" prop="whCode" align="center">
                        </el-table-column>
                        <el-table-column label="外协单号" prop="soCode" align="center">
                        </el-table-column>
                        <el-table-column label="物料编号" prop="matCode" align="center">
                        </el-table-column>
                        <el-table-column label="物料描述" prop="matName" align="center">
                        </el-table-column>
                        <el-table-column label="汇报完成物料编号" prop="matCheckCode" align="center">
                        </el-table-column>
                        <el-table-column label="批次" prop="batchNo" align="center">
                        </el-table-column>
                        <el-table-column label="数量" prop="boxQuan" palign="center">
                        </el-table-column>

                    </h-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" type="info" @click="clearOutsource(),editBoxShow = false">
                        取 消
                    </el-button>
                    <el-button size="small" type="primary" @click="insertOutsource()">
                        新 增
                    </el-button>
                </div>
            </el-dialog>

            <!-- 详情 -->
            <el-dialog title="外协详情列表" :visible.sync="detailsDialogShow" class="infoDialog" :close-on-click-modal="false" :show-close="false">
                <!-- <el-button type="primary" class="btn-t-edit" style="margin-top:10px;margin-bottom:10px;float: right;" @click="rePrintBarcode()">打印</el-button> -->
                <h-table :headerCellStyle="mainData.headerCellStyle" style="height: 56vh" :data="outsourceLists" @selectionChange="checkboxDet">
                    <el-table-column type="selection" align="center" :selectable="checkboxSelect">
                    </el-table-column>
                    <el-table-column label="通道" prop="whCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料描述" prop="matName" align="center">
                    </el-table-column>
                    <el-table-column label="外协供应商" prop="laOutsouceCode" align="center">
                    </el-table-column>
                    <!-- <el-table-column label="汇报后编号" prop="matCheckCode" align="center">
                    </el-table-column> -->
                    <el-table-column label="总数量" prop="boxQuan" palign="center">
                    </el-table-column>
                    <el-table-column label="已打印数量" prop="boxCheckQuan" palign="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.soStatus == '30'">{{scope.row.boxCheckQuan}}</span>
                            <span v-if="scope.row.soStatus == '90'">{{scope.row.boxCheckQuan}}</span>
                            <span v-if="scope.row.soStatus == '70'">{{scope.row.completeCount}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="当前打印数量" prop="completeCount" palign="center">
                    </el-table-column> -->
                    <el-table-column label="批次" prop="batchNo" align="center" width="100px">
                    </el-table-column>
                    <el-table-column label="入库时间" prop="fifDate" align="center" width="100px"></el-table-column>
                    <!-- <el-table-column label="箱号" prop="boxBarcode" align="center">
                    </el-table-column> -->
                  <!--
                    <el-table-column label="状态" prop="soStatus" align="center">
                        <template slot-scope="scope">
                             <div v-if="scope.row.soStatus == '20'">进行中</div>
                            <div v-if="scope.row.soStatus == '30'">外协出库</div>
                            <div v-if="scope.row.soStatus == '80'">外协出库</div>
                            <div v-if="scope.row.soStatus == '90'">外协出库</div>
                            <div v-if="scope.row.soStatus == '40'">收货完成</div>
                            <div v-if="scope.row.soStatus == '50'">关闭</div>
                            <div v-if="scope.row.soStatus == '70'">外协入库</div>
                        </template>
                    </el-table-column>-->
                    <el-table-column label="每箱数量" prop="boxQuan" palign="center">
                        <template slot-scope="scope" v-if="scope.row.soStatus == '70'">
                            <el-input-number v-model="scope.row.printCount" style="width: 100px;line-height: 26px !important" :min="0" size="mini"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column label="箱数" prop="boxQuan" palign="center">
                        <template slot-scope="scope" v-if="scope.row.soStatus == '70'">
                            <el-input-number v-model="scope.row.splitBoxCount" style="width: 100px;line-height: 26px !important" :min="0" :max="20" size="mini"></el-input-number>
                        </template>
                    </el-table-column>
                  <!--
                  <el-table-column label="操作">
                    <template slot-scope="scope" v-if="scope.row.soStatus == '70'">


                      <el-button v-authority="'BACK_MENU6_M4_B7'" class="btn-t-edit" type="primary" @click="editBoxShow = true,getOutsourceDetail(scope.row.soCode),(mainNum = JSON.parse(JSON.stringify(scope.row))),(oldMatQuan=JSON.parse(JSON.stringify(scope.row)).boxQuan)">修改数量</el-button>
                    </template>
                  </el-table-column>-->
                </h-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogClose" type="info">取 消</el-button>
                    <el-button @click="submitOutsource" type="danger">确 定</el-button>
                </div>
            </el-dialog>

          <!-- 编辑框 -->
          <el-dialog :title="'修改数量'" width="400px"  :close-on-click-modal="false" :visible.sync="editBoxShow" :model="mainNum" >

                <el-form :inline="true" label-position="top" label-width="80px"  :model="mainNum"  ref="mainNum">
                    <el-form-item label="数量" prop="boxQuan" style="padding-left: 100px;">
                        <el-input v-model="mainNum.boxQuan" oninput="value=value.replace(/[^\d]/g,'')">
                        </el-input>

                    </el-form-item>

                </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="editBoxShow=false">
                    取 消
                </el-button>

                <el-button size="small" type="primary" @click="editRow">
                    修 改
                </el-button>
            </span>
          </el-dialog>


        <!-- 打印 -->
        <el-dialog title="打印" :visible.sync="printShow" width="82%" :close-on-click-modal="false" style="height:100%">
            <div >
                <v-print :doPrint.sync="print">
                    <div id="demo" class="demo11">
                        <div style="margin-top:20px;margin-left:800px">
                            <el-button class="btn-t-info" type="info" @click="(printShow = false), (printList = [])">取消</el-button>
                            <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button>
                        </div>
                        <div class="div1">打印时间：{{printTime}}</div>
                        <div class="div">
                            <table border="1" cellpadding="0" cellspacing="0">
                                <thead style="display:table-header-group;font-weight:bold">
                                    <tr>
                                        <th>通道编号</th>
                                        <th>物料编号</th>
                                        <th>物料描述</th>
                                        <th>数量</th>
                                        <th>物料批次</th>
                                        <th>汇报完成的库位</th>
                                        <th>包装箱号</th>
                                        <th>外协单号</th>
                                        <th>是否扫描接收</th>
                                        <th>操作人</th>
                                        <th>工号</th>
                                        <th>创建时间</th>
                                        <th>更新时间</th>
                                    </tr>
                                </thead>
                                <tr v-for="(item, index) in printData" :key="index">
                                    <td>{{item.whCode}}</td>
                                    <td>{{item.matCode}}</td>
                                    <td>{{item.matName}}</td>
                                    <td>{{item.boxQuan}}</td>
                                    <td>{{item.batchNo}}</td>
                                    <td>{{item.laCheckCode}}</td>
                                    <td>{{item.boxBarcode}}</td>
                                    <td>{{item.soCode}}</td>
                                    <td>
                                        <span v-if="item.scanFlag == true">是</span>
                                        <span v-if="item.scanFlag == false">否</span>
                                    </td>
                                    <td>{{item.person}}</td>
                                    <td>{{item.perosnNumber}}</td>
                                    <td>{{item.createTime}}</td>
                                    <td>{{item.updateTime}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </v-print>
            </div>
            <div style="margin-top: 50px;height:70px">
                <!-- <el-button class="btn-t-edit" @click="(printShow = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button> -->
            </div>
        </el-dialog>


          <!-- 标签打印 -->
          <el-dialog  title="标签打印" :visible.sync="labelPrintShow" width="1200px" :close-on-click-modal="false" >
            <v-print :doPrint.sync="labelPrintFlag">
              <outsource-label-return :data="labelPrintData" />
            </v-print>
            <div style="margin-top: 50px;height:80px;text-align: center">
              <el-button class="btn-t-edit" @click="labelPrintShow = false">取消</el-button>
              <el-button class="btn-t-edit" @click="labelPrintFlag = true,labelPrintShow = false">打印</el-button>
            </div>
          </el-dialog>

          <el-dialog title="打印" :visible.sync="printShows" width="1500px" :close-on-click-modal="false">
            <v-print :doPrint.sync="prints">
              <div id="demo" class="demo">
                <div>
                  <div style="margin-left: -1200px; margin-top: 50px">
                    {{ printTime }}
                  </div>
                  <div style="margin-right: -1200px; margin-top: 50px">
                    <el-button size="small" type="primary" @click="clearPrintData">
                      清空数据
                    </el-button>
                  </div>
                  <div style="
                                font-size: 30px;
                                font-weight: 600;
                                margin-top: 20px;
                                text-align: center;
                                ">
                    外协送货单
                  </div>
                  <div class="div" style="margin-top: 10px; font-size: 20px">
                    <!-- <span>工序：</span> -->
                    <span>通道：{{whCodes}}</span>
                    <span>班次：</span>
                    <span>申请人：{{user}}</span>
                    <span>日期：{{ printTime }}</span>
                    <span>外协单号：{{soCode}}</span>

                  </div>
                  <div class="table">
                    <table width="100%" border="1" cellpadding="0" cellspacing="0">
                      <tr>
                        <th></th>
                        <th colspan="2" style="text-align: center;">通道下单</th>
                        <th colspan="4" style="text-align: center;">外协接单</th>
                        <!-- <th colspan="2">通道接料</th> -->
                      </tr>
                      <tr class="td">
                        <td>序号</td>
                        <td>型号</td>

                        <td>数量</td>
                        <td>实发库位</td>
                        <td>箱号</td>
                        <!-- <td>数量</td> -->
                        <td>实发数量</td>
                        <td>备注</td>
                      </tr>
                      <tr v-for="(item, index) in printData" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{item.matCode}}-{{item.matName}}</td>

                        <td>{{ item.boxQuan }}</td>
                        <td>{{ item.laCheckCode }}</td>
                        <td>{{ item.boxBarcode }}</td>
                        <td>{{ item.boxQuan }}</td>
                        <td></td>
                        <!-- <td>{{ item.matQuan }}</td> -->
                      </tr>
                    </table>
                  </div>
                  <div class="div" style="margin-top: 10px; font-size: 20px">
                    <span>总数量：{{ summarySumNumber }}</span>
                    <span>箱数：{{ boxNumber }}</span>
                    <span style="width:100px">车间签字：</span>
                    <span style="padding-left: 250px;">仓库签字：</span>
                    <span style="float:right;margin-right:90px">供应商签字：</span>
                  </div>
                </div>
              </div>
            </v-print>

            <div style="margin-top: 50px;height:80px;text-align: center;">
              <el-button class="btn-t-edit" @click="(printShows = false)">取消</el-button>
              <el-button class="btn-t-edit" @click="prints=true,printShows=false">打印</el-button>
            </div>
          </el-dialog>

        </box>
    </div>
</template>

<script>
    import moment from "moment";
    import OutsourceLabelReturn from "@/views/printPages/outsource-label-return.vue";
    import vPrint from 'syl-vue-printer'
    export default {
        name: "supplierOutsource",
        components: {
          OutsourceLabelReturn,
          vPrint

        },
        data() {
            return {
                printData: [], //打印数据
                print: false,
                printShow: false,
                prints: false,
                printShows: false,
                printObj: {
                    id: "demo",
                    popTitle: "",
                },
                user:localStorage.getItem("user"),
                summarySumNumber:0,
                boxNumber:"",
                soCode:"",
                printTime: moment(new Date).format("yyyy-MM-DD"),
                editNumShow:false,
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                whCodes:"",
                oldMatQuan:"",
                form: {},
              // 标签打印
                labelPrintShow: false,
                labelPrintFlag: false,
                labelPrintData: null,
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                },
              mainNum:{
                nowNum:"",
              },
				searchInfo: {
                    soCode: "",
                    boxBarcode: "",
                    matCode: "",
                    person: "",
                    soStatus: "30,80,90",
                    whCode: localStorage.getItem("whCode") || "",
                    //laCode: "",
                    laCode: localStorage.getItem("empNumber") || "",
                    supplyNumber: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: []
				},
                printObjs:{
                    matCode:"",
                    batchNo:"",
                    soCode:""
                },

                warehouseList: [],
                mainObj: {
                    soCode: "",
                    laOutsouceCode: "",
                    boxBarcode: ""
                },
                rules: {
                    soCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    laOutsouceCode: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    boxBarcode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },

                addOutsourceList: [],

                laCodeList: [],
                checkOutsourceList: [], //多选

                editBoxShow: false,

                downloadLoading: false, //下载中

                detailsDialogShow: false,
                detailsDialogShows:false,
                outsourceLists: [],
                checkListDet: [], //全选

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
                //打印显示
                outsourcePrintList:[],
                checkoutsourcePrintList: [], //多选
            };
        },
        watch: {
            searchInfo: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getOutsource(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.searchInfo.requireDate[0]) {
                            return time.getTime() < new Date(_this.searchInfo.requireDate[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.searchInfo.requireDate[1]) {
                            return time.getTime() > new Date(_this.searchInfo.requireDate[1]);
                        }
                    }
                }
            },
        },
        methods: {
          //表单验证
          submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
              if (valid) {
                r = true;
              } else {
                r = false;
              }
            });
            return r;
          },
          //编辑
          editRow() {
            if (this.submitForm("mainNum")) {
              if(this.mainNum.boxQuan == 0){
                this.$message({
                  type: "warning",
                  message: "数量不能为0！",
                });
                return
              }
              if(this.oldMatQuan<this.mainNum.boxQuan){
                this.$message({
                  type: "warning",
                  message: "不能大于外协单数量！",
                });
                return
              }
              if(this.oldMatQuan==this.mainNum.boxQuan){
                this.$message({
                  type: "warning",
                  message: "修改的数量不能一样！",
                });
                return
              }
              this.$http
                  .request({
                    url: "/api/outsource/updateBoxQuan",
                    method: "POST",
                    showLoading: true,
                    data: this.mainNum,
                    params: {
                      person: localStorage.getItem("user"),
                      personNumber: localStorage.getItem("empNumber"),
                    }
                  })
                  .then((resp) => {
                    if (resp.status == 100) {
                      this.$notify({
                        title: "成功",
                        message: "修改成功！",
                        type: "success",
                      });
                      this.logRemarks = "supplieroutsource：修改成功为："+this.mainNum.boxQuan;
                      this.editBoxShow = false;
                    } else {
                      this.$notify.error({
                        title: "失败",
                        message: resp.message,
                      });
                      this.logRemarks = "supplieroutsource：修改失败"+this.mainNum.boxQuan;
                    }
                    this.logContent = "boxQuan：" + this.mainNum.boxQuan;
                    this.systemLog();
                    this.getOutsourceDetail(this.mainNum.soCode);
                  })
                  .catch((error) => {
                    this.$notify.error({
                      title: "失败",
                      message: "调用失败",
                    });
                  });
            }
          },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getOutsource()
                }, 1000)
            },
            //获取数据
            getOutsource() {
                this.$http
                    .request({
                        url: "/api/outsource/getOutsourceData",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum || null,
                            pageSize: this.pagination.pageSize || null,
                            // supplyNumber: this.searchInfo.supplyNumber || null,
                            soCode: this.searchInfo.soCode || null,
                            matCode: this.searchInfo.matCode || null,
                            boxBarcode: this.searchInfo.boxBarcode || null,
                            fcCode: this.searchInfo.fcCode || null,
                            person: this.searchInfo.person || null,
                            laCode: this.searchInfo.laCode || null,
                            whCode: this.searchInfo.whCode || null,
                            soStatus: this.searchInfo.soStatus || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            //手动汇报
            manualReport() {
                if (this.checkOutsourceList.length == 0) {
                    this.$message({
                        type: "warning",
                        message: "请选择外协单！",
                    });
                    return
                }
                let num = 0;
                this.checkOutsourceList.forEach((item) => {
                    if (item.soStatus == 30) {
                        num += 1
                    }
                })
                if (num != 0) {
                    this.$message({
                        type: "warning",
                        message: "汇报完成的外协单不再进行汇报！",
                    });
                    return
                }
                this.$confirm("是否进行手动汇报操作? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/outsource/manualReport",
                                method: "POST",
                                showLoading: true,
                                data: this.checkOutsourceList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                }
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "操作成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "outsource：手动汇报操作成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: res.message,
                                    });
                                    this.logContent = JSON.stringify(this.checkOutsourceList);
                                    this.systemLog();
                                    this.logRemarks = "outsource：手动汇报操作成功";
                                }
                                this
                                this.getOutsource();
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            //查询添加数据
            selOutsourceList() {
                this.addOutsourceList = []
                this.$http
                    .request({
                        url: "/api/outsource/getOutsourceDetail",
                        method: "GET",
                        params: {
                            soCode: this.mainObj.soCode || null,
                            fcCode: localStorage.getItem("fcCode") || null,
                            statusList: "30" || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.list != null) {
                                let list = resp.data.list;
                                list.forEach((item) => {
                                    let tabData = {
                                        soId: item.soId,
                                        whCode: item.whCode,
                                        soCode: item.soCode,
                                        laCode: item.laCode,
                                        laOutsouceCode: item.laOutsouceCode,
                                        laCheckCode: item.laCheckCode,
                                        matCode: item.matCode,
                                        matName: item.matName,
                                        matCheckCode: item.matCheckCode,
                                        boxBarcode: item.boxBarcode,
                                        boxQuan: item.boxQuan,
                                        batchNo: item.batchNo
                                    }
                                    this.addOutsourceList.push(tabData)
                                })
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "未找到记录！",
                                });
                            }
                            // console.log(this.addOutsourceList)
                        }
                    })
                    .catch((error) => {});
            },
            deletePrint(){
                 if (this.checkoutsourcePrintList.length == 0) {
                    this.$message({
                        type: "warning",
                        message: "请选择外协汇报记录！",
                    });
                    return
                }else if(this.checkoutsourcePrintList.length>1){
                   this.$message({
                     type: "warning",
                     message: "只能操作一条！",
                   });
                   return
                 }else{
                    var sopIds = "";
                    var isreturn = false;
                    this.checkoutsourcePrintList.forEach((item)=>{
                        if(item.scanFlag == '1'){
                          this.$message({
                            type: "warning",
                            message: "已经接收的不能删除！",
                          });
                          isreturn = true;
                        }
                        sopIds += item.sopId + ","
                    })
                   if(isreturn){
                     return;
                   }
                    this.$confirm("是否删除该外协汇报记录? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/outsource/deleteOutsourcePrint",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    sopIds:sopIds,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        type: "success",
                                        message: "删除成功！",
                                    });
                                    this.getOutsourcePrintList();
                                    this.logRemarks = "outsource：删除外协汇报记录成功(修改)";
                                } else {
                                    this.$message({
                                        type: "warning",
                                        message: resp.message,
                                    });
                                    this.logRemarks = "outsource：删除外协汇报记录失败(修改)";
                                }
                            })
                            .catch((error) => {
                                this.loading++;
                            });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },

            //新增数据
            insertOutsource() {
                if (this.addOutsourceList.length == 0) {
                    this.$message({
                        type: "warning",
                        message: "未找到提交记录！",
                    });
                    return
                }
                this.$http
                    .request({
                        url: "/api/outsource/insertSupplierOutsource",
                        method: "POST",
                        showLoading: true,
                        data: this.addOutsourceList,
                        params: {
                            person: localStorage.getItem("user") || null,
                            perosnNumber: localStorage.getItem("empNumber") || null,
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                type: "warning",
                                message: "新增成功！",
                            });
                            this.editBoxShow = false;
                            this.getOutsource();
                            this.logRemarks = "outsource：新增供应商外协记录成功(修改)";
                        } else {
                            this.$message({
                                type: "warning",
                                message: resp.message,
                            });
                            this.logRemarks = "outsource：新增供应商外协记录失败(修改)";
                        }
                        this.logContent = JSON.stringify(this.addOutsourceList);
                        this.systemLog();
                        this.clearOutsource();
                    })
                    .catch((error) => {
                        this.loading++;
                    });
                
            },
            //多选
            selectOutsource(val) {
                this.checkOutsourceList = val;
            },

            //关闭外协单
            closeSupplierOutsourcing() {
                if (this.checkOutsourceList.length == 0) {
                    this.$message({
                        type: "warning",
                        message: "请选择外协单！",
                    });
                    return
                }
                const res = this.checkOutsourceList.every(e => {
                    if (e.soStatus != "30"&&e.soStatus != "80") {
                        this.$message({
                            type: "warning",
                            message: "进行中状态的外协单才能关闭！",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }

                this.$confirm("是否关闭该外协单? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/outsource/closeOutsourcing",
                                method: "POST",
                        showLoading: true,
                                data: this.checkOutsourceList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                }
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "操作成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "outsource：关闭供应商外协单成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: res.message,
                                    });
                                    this.logContent = JSON.stringify(this.checkOutsourceList);
                                    this.systemLog();
                                    this.logRemarks = "outsource：关闭供应商外协单成功";
                                }
                                this.getOutsource();
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

          confirmReceipt() {
            if (this.checkOutsourceList.length == 0) {
              this.$message({
                type: "warning",
                message: "请选择外协单！",
              });
              return
            }
            const res = this.checkOutsourceList.every(e => {
              if (e.soStatus != "80") {
                this.$message({
                  type: "warning",
                  message: "待接收状态的外协单才能接收！",
                });
                return false;
              } else {
                return true;
              }
            })
            if (res == false) {
              return false;
            }

            this.$confirm("是否接收该外协单? ", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            })
                .then(() => {
                  this.$http
                      .request({
                        url: "/api/outsource/confirmReceipt",
                        method: "POST",
                        showLoading: true,
                        data: this.checkOutsourceList,
                        params: {
                          person: localStorage.getItem("user"),
                          personNumber: localStorage.getItem("empNumber"),
                        }
                      })
                      .then((res) => {
                        if (res.status == 100) {
                          this.$notify({
                            title: "成功",
                            message: "操作成功！",
                            type: "success",
                          });
                          this.logRemarks = "outsource：确认接收供应商外协单成功";
                        } else {
                          this.$notify.error({
                            title: "失败",
                            message: res.message,
                          });
                          this.logContent = JSON.stringify(this.checkOutsourceList);
                          this.systemLog();
                          this.logRemarks = "outsource：确认接收供应商外协单失败";
                        }
                        this.getOutsource();
                      });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消",
                  });
                });
          },

          outbound() {
            if (this.checkOutsourceList.length == 0) {
              this.$message({
                type: "warning",
                message: "请选择外协单！",
              });
              return
            }
            const res = this.checkOutsourceList.every(e => {
              if (e.soStatus != "90") {
                this.$message({
                  type: "warning",
                  message: "确认接收状态的外协单才能出库！",
                });
                return false;
              } else {
                return true;
              }
            })
            if (res == false) {
              return false;
            }

            this.$confirm("是否出库该外协单? ", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            })
                .then(() => {
                  this.$http
                      .request({
                        url: "/api/outsource/outbound",
                        method: "POST",
                        showLoading: true,
                        data: this.checkOutsourceList,
                        params: {
                          person: localStorage.getItem("user"),
                          personNumber: localStorage.getItem("empNumber"),
                        }
                      })
                      .then((res) => {
                        if (res.status == 100) {
                          this.$notify({
                            title: "成功",
                            message: "操作成功！",
                            type: "success",
                          });
                          this.logRemarks = "outsource：出库供应商外协单成功";
                        } else {
                          this.$notify.error({
                            title: "失败",
                            message: res.message,
                          });
                          this.logContent = JSON.stringify(this.checkOutsourceList);
                          this.systemLog();
                          this.logRemarks = "outsource：出库供应商外协单失败";
                        }
                        this.getOutsource();
                      });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消",
                  });
                });
          },

            //打印多选
            selectOutsourcePrint(val) {
                this.checkoutsourcePrintList = val;
            },

            //取消
            dialogPrintClose() {
                this.outsourcePrintList=[];
                this.detailsDialogShows = false;
                this.checkoutsourcePrintList = [];
                this.getOutsource();
                this.printObjs={}
            },

             pdfPrint() {
                if (JSON.parse(JSON.stringify(this.checkoutsourcePrintList)).length == 0) {
                    this.$message({
                        message: "请选择外协记录！",
                        type: "warning",
                    });
                    return;
                }
                this.printShows = true;
                this.printData = JSON.parse(JSON.stringify(this.checkoutsourcePrintList));
                this.whCodes = this.printData[0].whCode;
                this.soCode = this.printData[0].soCode;
                this.summarySumNumber = 0;
                this.printData.forEach((item) => {
                   this.summarySumNumber += item.boxQuan;
                })
                 this.boxNumber = this.printData.length;

            },

            // 禁选
            checkboxSelect(row, rowIndex) {
                // if (row.soStatus != "30") {
                //     return false; // 禁用
                // } else {
                //     return true; // 不禁用
                // }
                return true;
            },

            //标签打印
            rePrintBarcode() {
                if (this.checkListDet.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                let num = 0;
                this.checkListDet.forEach((item) => {
                    if (item.soStatus == 20) {
                        num += 1
                    }
                })
                if (num != 0) {
                    this.$message({
                        type: "warning",
                        message: "汇报完成的外协单才能进行打印！",
                    });
                    return
                }
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.checkListDet.forEach((data) => {
                        this.$http
                            .request({
                                url: "/api/outsource/getOutsourceInventory",
                                method: "GET",
                                showLoading: true,
                                params: {
                                    soCode: this.checkListDet[0].soCode || null, // 外协编号
                                },
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    let item = res.data.list[0];
                                    var produceTime = moment(data.matProduceTime).format("YYYYMMDD");

                                    var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                            item.matCode + "," + item.boxQuan + "," + item.matSpecs +
                                            "," + item.batchNo + "," + produceTime + ",2,,,";

                                    if (item.matSpecs == undefined) {
                                        item.matSpecs = "";
                                    }

                                    var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                    var barcodeData = {
                                        boxBarcode: item.boxBarcode,
                                        prodCode: item.matCode,
                                        prodName: item.matName,
                                        batchNo: item.batchNo,
                                        count: item.boxQuan,
                                        checkPerson: localStorage.getItem("empNumber"),
                                        date: produceTime,
                                        poCode: item.orderCode,
                                        matSpecs: item.matSpecs,
                                        whCode: item.whCode,
                                        qrCode: qrCode,
                                        supply: localStorage.getItem("userName"),
                                        printTime: printTime,
                                        printTwo: 1,
                                        supplyName: localStorage.getItem("userName"),
                                        // fcAddress: localStorage.getItem("fcCode")=='DLM'?'铁山东三路53号':'淮河中路87号',
                                        fcAddress: item.fcCode=='DLM'?'铁山东三路53号':'淮河中路87号',
                                        fcName: "斯凯孚大连轴承与精密技术有限公司"
                                    }

                                    // console.log(barcodeData);

                                    this.$printer.printWMSSupplyBarcode(barcodeData);
                                }
                                this.lazyNext = setTimeout(() => {
                                    this.lazyNext = null
                                }, 5000)
                            });
                    })

                }
                this.detailsDialogShow = false;
            },

            //全选
            checkboxDet(val) {
                this.checkListDet = val;
            },
            //取消
            dialogClose() {
                this.detailsDialogShow = false;
                this.outsourceLists = [];
                this.getOutsource();
            },
            //获取详情
            getOutsourceDetail(soCode) {
                this.$http
                    .request({
                        url: "/api/outsource/getOutsourceDetail",
                        method: "GET",
                        params: {
                            soCode: soCode || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.outsourceLists = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            //获取打印数据
            getOutsourcePrintList(){
                 this.$http
                    .request({
                        url: "/api/outsource/getOutsourcePrintList",
                        method: "GET",
                        params: {
                            soCode: this.printObjs.soCode || null,
                            matCode: this.printObjs.matCode || null,
                            batchNo: this.printObjs.batchNo || null,
                            laCheckCode:localStorage.getItem("user"),
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                                this.outsourcePrintList = resp.data.list || []
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "未找到记录！",
                                });
                            }
                            this.tablesoCode = ""
                    })
            },



            //清除
            clearOutsource() {
                this.mainObj = {
                    soCode: "",
                    laOutsouceCode: "",
                    boxBarcode: ""
                }
                this.addOutsourceList = []
            },

            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
				};
				this.searchInfo = {
                    soCode: "",
                    boxBarcode: "",
                    matCode: "",
                    person: "",
                    soStatus: "30",
                    whCode: localStorage.getItem("whCode") || "",
                    laCode: "",
                    supplyNumber: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: []
                };
                this.getOutsource();
            },
            /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/checkTask/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.warehouseList = res.data;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            //获取WX库位
            getlaCode() {
                this.$http
                    .request({
                        url: "/api/location/getLocationAll",
                        method: "GET",
                        params: {
                            lcType: "WX",
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.laCodeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //表格导出
            downLoadFile() {
                if (this.checkOutsourceList.length == 0) {
                    this.$message({
                        message: "请选择记录单",
                        type: "warning",
                    });
                    return
                }
                let list = [];
                this.checkOutsourceList.forEach((item) => {
                    list.push(item.soCode)
                })
                var soCode = list.join(",")
                this.downloadLoading = true;
                var paramsObj = {
                    soCode: soCode,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/outsource/getOutsourceDetail',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        // if (c.soStatus == '10') {
                        //     c['soStatus'] = '创建'
                        // } else if (c.soStatus == '20') {
                        //     c['soStatus'] = '进行中'
                        // } else if (c.soStatus == '30') {
                        //     c['soStatus'] = '报检完成'
                        // } else if (c.soStatus == '40') {
                        //     c['soStatus'] = '收货完成'
                        // } else if (c.soStatus == '50') {
                        //     c['soStatus'] = '关闭'
                        // }
                        if (c.soStatus == '80') {
                            c['soStatus'] = '待接收'
                        } else if (c.soStatus == '40') {
                            c['soStatus'] = '收货完成'
                        } else if (c.soStatus == '90') {
                          c['soStatus'] = '发货完成'
                        } else if (c.soStatus == '30') {
                          c['soStatus'] = '出库完成'
                        } else if (c.soStatus == '50') {
                            c['soStatus'] = '关闭'
                        }else if (c.soStatus == '70') {
                            c['soStatus'] = '完成'
                        }

                        if (c.scanFlag == true) {
                            c['scanFlag'] = '是'
                        } else if (c.scanFlag == false) {
                            c['scanFlag'] = '否'
                        }
                    })
                    const tHeader = ['通道', '外协单号', '库位', '外协供应商', '外协报检库位', '箱数物料编号', '物料描述', '汇报完成的物料编号', '箱号', '箱数', '批次',
                        '状态', '是否扫描确认', '供应商账号', '操作人', '创建人', '更新时间', '创建时间'
                    ]
                    const filterVal = ['whCode', 'soCode', 'laCode', 'laOutsouceCode', 'laCheckCode', 'matCode', 'matName', 'matCheckCode', 'boxBarcode', 'boxQuan', 'batchNo',
                        'soStatus', 'scanFlag', 'supplyNumber', 'person', 'personNumber', 'updateTime', 'createTime'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '供应商外协数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_outsource：导出供应商外协数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/checkTask/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.warehouseList = res.data;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            //获取WX库位
            getlaCode() {
                this.$http
                    .request({
                        url: "/api/location/getLocationAll",
                        method: "GET",
                        params: {
                            lcType: "WX",
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.laCodeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "供应商外协",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },

            /**
            *提交并且打印标签
             */
            submitOutsource() {

                if(this.checkListDet.length == 0){

                    this.$message.warning({
                        title: "提示",
                        message: "请选择待打印记录",
                    });

                    return false;
                }
              if(this.checkListDet.length > 1){

                this.$message.warning({
                  title: "提示",
                  message: "只能选择一条打印",
                });

                return false;
              }

                for(var idx in this.outsourceLists){
                    this.outsourceLists[idx].nowPrintCount = 0;
                }

                for(var index in this.checkListDet){
                    if(this.checkListDet[index].printCount == "" || this.checkListDet[index].printCount == undefined){
                        this.$message.warning({
                            title: "提示",
                            message: "选中打印记录中的数量不能为空！",
                        });
                        return;
                    }
                    if(this.checkListDet[index].splitBoxCount == "" || this.checkListDet[index].splitBoxCount == undefined){
                        this.$message.warning({
                            title: "提示",
                            message: "选中打印记录中的箱数不能为空！",
                        });
                        return;
                    }
                    if(this.checkListDet[index].splitBoxCount>1){
                      // this.$message.warning({
                      //   title: "提示",
                      //   message: "一次只能打印一张",
                      // });
                      //
                      // return false;
                    }
                    
                    if((this.checkListDet[index].boxQuan - this.checkListDet[index].completeCount) < (this.checkListDet[index].printCount * this.checkListDet[index].splitBoxCount)){
                        this.$message.warning({
                            title: "提示",
                            message: "打印数量超过当前总数量",
                        });
                        return;
                    }


                    for(var idx in this.outsourceLists){

                        if(this.outsourceLists[idx].soStatus == '30' && this.outsourceLists[idx].batchNo == this.checkListDet[index].batchNo){

                            this.outsourceLists[idx].nowPrintCount += (this.checkListDet[index].printCount * this.checkListDet[index].splitBoxCount);

                        }

                    }
                }

                //计算当前可打印数量

                for(var idx in this.outsourceLists){
                    if(this.outsourceLists[idx].soStatus == '30' && (this.outsourceLists[idx].boxQuan - this.outsourceLists[idx].boxCheckQuan)
                        < this.outsourceLists[idx].nowPrintCount){

                        this.$message.warning({
                            title: "提示",
                            message: this.outsourceLists[idx].batchNo + "打印数量超过当前外协总数量",
                        });
                        return;

                    }
                }

                this.checkListDet[0].person = localStorage.getItem("user");
                this.checkListDet[0].personNumber = localStorage.getItem("empNumber");

                // return;

                this.$confirm("提交并且打印标签? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/outsource/insertOutsourcePrint",
                                method: "POST",
                                showLoading: true,
                                data: this.checkListDet
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$message({
                                        title: "成功",
                                        message: "操作成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "outsource：外协标签打印";
                                    this.getOutsourceDetail(this.checkListDet[0].soCode);

                                    var returnData = res.data;

                                    //标签打印
                                    returnData.forEach((item) => {
                                      var produceTime = moment(item.fifoDate).format("YYYYMMDD");
                                      //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                      // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                                      //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                                      //     "/" + produceTime + "/" + item.boxHeight + "/";

                                      //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                      var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                          item.matCode + "," + item.boxQuan + "," + item.matSpecs +
                                          "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                                      if (item.matSpecs == undefined) {
                                        item.matSpecs = "";
                                      }

                                      var person = localStorage.getItem("user");
                                      if (person != undefined && person != '') {
                                        person = item.consignee;
                                      }

                                      var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                      var barcodeData = {
                                        boxBarcode: item.boxBarcode,
                                        prodCode: item.matCode,
                                        prodName: item.matName,
                                        batchNo: item.batchNo,
                                        count: item.boxQuan,
                                        checkPerson: person,
                                        date: produceTime,
                                        poCode: item.orderCode,
                                        matSpecs: item.matSpecs,
                                        whCode: item.whCode,
                                        qrCode: qrCode,
                                        supply: item.verdorCode,
                                        printTime: printTime,
                                        isSta: false,
                                        printTwo: false,
                                        location: item.laCheckCode,
                                        boxHeight: item.boxHeight,
                                        heatBatchNo: item.heatNumber,
                                        luhao: item.heatNo,
                                        oldBoxbarcode: this.checkListDet[0].soCode,
                                        checkResult: "20"
                                      }
                                      this.$printer.printWMSBarcode(barcodeData);





                                      //this.labelPrintShow = true;
                                      var produceTime = moment(item.matCreateTime).format("YYYYMMDD");
                                      var printTime = moment().format("YYYY-MM-DD");
                                      var qrCode = item.orderCode+","+item.matCode+","
                                          +","+item.verdorCode+","+item.whCode+",,"+item.batchNo+
                                          ","+item.heatNumber+","+item.matSpecs+","+item.checkType+","+item.boxQuan+
                                          ","+item.palletCode+","+item.boxBarcode+",,,"+produceTime+","+item.soCode;
                                      this.labelPrintData = {
                                        value1: item.boxBarcode,
                                        value2: qrCode,
                                        soCode:item.soCode,
                                        matCode:item.matCode,
                                        matName:item.matName,
                                        whCode:item.whCode,
                                        printTime:printTime,
                                        matQuan:item.boxQuan,
                                        batchNo:item.batchNo,
                                        palletCode:item.palletCode,
                                        boxBarcode:item.boxBarcode,
                                        laOutsouceCode:item.laCheckCode,
                                        wxName:localStorage.getItem("user"),
                                        isFg:item.checkResult='20'?'否':'是',
                                        type:item.checkType,
                                        matSumQuan:item.matSumQuan,

                                      }

                                      /*
                                        var produceTime = moment().format("YYYYMMDD");


                                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                        var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                            item.matCode + "," + item.boxQuan + "," + item.matSpecs +
                                            "," + item.batchNo + "," + produceTime + ",2,,,";

                                        if (item.matSpecs == undefined) {
                                            item.matSpecs = "";
                                        }

                                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                        var barcodeData = {
                                            boxBarcode: item.boxBarcode,
                                            prodCode: item.matCode,
                                            prodName: item.matName,
                                            batchNo: item.batchNo,
                                            count: item.boxQuan,
                                            checkPerson: localStorage.getItem("empNumber"),
                                            date: produceTime,
                                            poCode: item.orderCode,
                                            matSpecs: item.matSpecs,
                                            whCode: item.whCode,
                                            qrCode: qrCode,
                                            supply: localStorage.getItem("userName"),
                                            printTime: printTime,
                                            printTwo: 2,
                                            supplyName: localStorage.getItem("userName"),
                                            // fcAddress: localStorage.getItem("fcCode")=='DLM'?'铁山东三路53号':'淮河中路87号',
											fcAddress: item.fcCode=='DLM'?'铁山东三路53号':'淮河中路87号',
                                            fcName: "斯凯孚大连轴承与精密技术有限公司"
                                        }

                                        // console.log(barcodeData);

                                        this.$printer.printWMSSupplyBarcode(barcodeData);

                                       */
                                    })
                                } else {
                                    this.$message.error({
                                        title: "失败",
                                        message: res.message,
                                    });
                                    this.logContent = JSON.stringify(this.checkOutsourceList);
                                    this.systemLog();
                                    this.logRemarks = "outsource：外协标签打印";
                                }
                                this.getOutsource();
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });



            }

        },
        activated(){
            /* 获取首页的数据 */
            this.getOutsource();
            this.getWarehouse();
            console.log();
        },
    };
</script>

<style>
.div span {
  margin-left: 50px;
}

.table table {
  margin-top: 20px;
}

.table table tr td {
  width: 100px;
  height: 50px;
  border: 1px solid black;
  text-align: center;
}

.table table tr th {
  width: 100px;
  height: 80px;
  border: 1px solid black;
  font-weight: 800;
  font-size: 18px;
}

.td td {
  font-weight: 800;
}
</style>
